<div class="cookie-section">
  <div class="cookie-container flex-display" *ngIf="contentAvailable">
    <span class="font-18" [innerHTML]="cookieText"></span>
    <button class="btn-primary-action-add cookie-button" (click)="cookieAcceptClick()">
      Accept
    </button>
  </div>
</div>
